import type { TowerDesign } from "@/game/towerSpec";
/**
 * West Hartford 125 ft guyed tower (West Hartford CT), from reference_towers/
 * 02_engineering_drawings/CT_WestHartford_guyed_100ft_structural.pdf.
 * EXACT: overall 125.00 ft (38.1 m), 3x (triangular) ROHN-class guyed, face width
 * 3.04 ft at top, tapered at base → top circumradius 0.535 m, base ~0.70 m (est).
 * 105 mph, 0.5"/1.0" ice cases. Report notes 7 guy attachment points → 5 modelled
 * levels (attach heights not cleanly tabulated, flagged).
 */
export const design: TowerDesign = {
  id: "guyed-westhartford-125ft",
  name: "Guyed Tower (West Hartford 125 ft)",
  description: "Real 125 ft triangular guyed tower, West Hartford CT (105 mph).",
  author: "reference: CT West Hartford 100/125 ft SA",
  spec: {
    type: "guyed",
    height: 38.1,
    stack: { faces: 3, panels: 25, baseRadius: 0.7, topRadius: 0.535,
      legSection: "legHeavy", braceSection: "braceHeavy", legMaterial: "a572", braceMaterial: "a572", bracing: "X" },
    guys: [0.24, 0.42, 0.6, 0.78, 0.96].map((f, i) => ({ atHeightFrac: f, anchorRadius: 14 + i * 4, section: "guy14", material: "guyStrand", pretensionStrain: 0.001 })),
    foundation: { soil: "stiff-clay", base: { type: "pier", width: 0.5, diameter: 0.5, depth: 1.2, concrete: "c20" }, anchor: { type: "deadman", width: 1.2, diameter: 0.5, depth: 1.8, concrete: "c20" } },
  },
};
